module.exports = __webpack_public_path__ + "img/fmk-fans.3e43d04b.jpg";